var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OurPage',{staticClass:"access-groups",attrs:{"back-route":_vm.backRoute,"title":_vm.$t('title.bonuses._'),"width":"md"}},[_c('OurTableList',{attrs:{"have-permission-edit":_vm.getPermission['bonus_program.bonus_program'],"list":_vm.bonusTextsSections},on:{"clickEdit":_vm.onClickEdit,"dragSort":_vm.dragHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }